import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";

const getAuthToken = () => localStorage.getItem("authToken");

const ExamMarkEntry = () => {
  const navigate = useNavigate();
  const { examId } = useParams();
  const [exam, setExam] = useState(null);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingIndex, setSavingIndex] = useState(null);
  const inputRefs = useRef([]);

  const fetchStudents = async (examId) => {
    const token = getAuthToken();
    try {
      const res = await axios.get(
        `${appConstants.API_ROOT_URL}get-exam-students?exam_id=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.data.status === "success") {
        setExam(res.data.exam);
        setStudents(res.data.students);
      }
    } catch (err) {
      console.error("Failed to fetch students", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents(examId);
  }, [examId]);

  const handleMarkChange = (index, value) => {
    const updated = [...students];
    updated[index].marks_obtained = value.toUpperCase();
    setStudents(updated);
  };

  const saveMark = async (student, index) => {
    const token = getAuthToken();
    setSavingIndex(index);
  
    try {
      const response = await axios.post(
        `${appConstants.API_ROOT_URL}save-mark`,
        {
          exam_id: examId,
          student_id: student.student_id,
          marks_obtained: student.marks_obtained,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.data.status !== "success") {
        throw new Error(response.data.message || "Failed to save mark");
      }
    } catch (err) {
      console.error("Error saving mark:", err);
  
      // Show a temporary error on the input field or alert
      alert(
        `Failed to save mark for ${student.name}: ${
          err.response?.data?.message || err.message
        }`
      );
    } finally {
      setSavingIndex(null);
    }
  };
  
  const handleBackClick = () => {
    navigate(-1);
  }

  const handleKeyPress = async (e, index) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault(); // Prevent form submission or default tabbing

      await saveMark(students[index], index);

      const nextIndex = index + 1;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  };

  return (
    <Layout>
      <div className="container mt-3">
        {/* Flex container for title and back button */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h4>Enter Marks</h4>
            <p>{exam?.name} - {exam?.subject_name} - {exam?.batch_name}</p>
          </div>
          <button
            className="btn btn-secondary"
            onClick={handleBackClick}
          >
            <i className="fas fa-arrow-left"></i> Back
          </button>
        </div>


        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Mark (or 'A')</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student, index) => (
                  <tr key={student.student_id}>
                    <td>{student.name}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={student.marks_obtained || ""}
                        onChange={(e) =>
                          handleMarkChange(index, e.target.value)
                        }
                        onKeyDown={(e) => handleKeyPress(e, index)}
                        ref={(el) => (inputRefs.current[index] = el)}
                        disabled={savingIndex === index}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {savingIndex !== null && (
          <div className="text-end text-secondary">
            <i className="fas fa-spinner fa-spin"></i> Saving...
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ExamMarkEntry;
